import { Card, CardProps } from 'antd';
import { FC } from 'react';

type CardAtomProps = CardProps;

const CardAtom: FC<CardAtomProps> = Card;

export default CardAtom;
